import WeightContent from 'components/admin/manage/edd/weight/WeightContent';
import React from 'react';

export const WeightPage = () => {
  return <WeightContent />;
};
